'use strict';


module.exports = function (client) {

    client.disco.addFeature('jabber:x:oob');
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/oob.js
// module id = 622
// module chunks = 2